import { Result } from "antd";
import React from "react";
import I18n from "../../i18n";

export function NetworkError() {
  return <Result status="500" subTitle={I18n.general.networkError} />;
}
